import React from "react";
import { SelectInputComponent } from "../../../../common/components";
import {TYPE_OPTIONS } from "../../../../constants/campaignDropdown";
import "./filter-options-select.scss"
interface LeadStatusFilterProps {
  value: string[];
  onChange: (value: string[]) => void;
  isTypeEnabled?: boolean;
  typeError?: any;
}

const TypeFilter: React.FC<LeadStatusFilterProps> = ({
  value,
  onChange,
  isTypeEnabled,
  typeError
}) => {
  if (!isTypeEnabled) return null;


  return (
    <div className="filter-select-input-wrapper" >
      <SelectInputComponent
        fieldName="type"
        options={TYPE_OPTIONS}
        onChange={onChange}
        value={value}
        placeholder="Select Type"
        multiple={true}
        isFilter={true}
      />
      {typeError && <div className="error-text">{typeError}</div>}
    </div>
  );
};

export default TypeFilter;
